<template>
  <div class="wrapper" :style="cssProps">
    <div class="header">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["add_credit_card"] }}
        </p>
      </div>
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["set_credit_card_info"] }}
      </p>
      <div id="payment-form">
        <div id="card-container">
          <div class="loading">
            <pulse-loader
              :color="'#af7c00'"
              :size="'2em'"
              :loading="loading"
            ></pulse-loader>
          </div>
        </div>
      </div>
      <div class="rest-text">
        {{ this.$store.getters.TRANSLATIONS["*rest_assured"] }}
        <br />{{ this.$store.getters.TRANSLATIONS["details_on_this_website"] }}
        <br />{{ this.$store.getters.TRANSLATIONS["stored_by_authorize"] }}
        <br />{{ this.$store.getters.TRANSLATIONS["payment_gateway"] }}
      </div>
    </div>
    <div class="footer">
      <button v-on:click="addCard()" class="button" v-if="!loading2">
        {{ this.$store.getters.TRANSLATIONS["save"] }}
      </button>
      <div class="loading">
        <pulse-loader
          :color="'#af7c00'"
          :size="'2em'"
          :loading="loading2"
        ></pulse-loader>
      </div>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: async function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    }
    if (!this.square) {
      throw new Error("Square.js failed to load properly");
    } else {
      await this.initWalletPayments();
    }
  },
  data() {
    return {
      loading: false,
      loading2: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),

      back: () => {
        if (this.$route.query.returnTo) {
          this.$router.push(`/${this.$route.query.returnTo}`);
        } else {
          this.$router.push("/payWithSquareUpCreditCard");
        }
      },
      icon: require("@/assets/icon_back.png"),
      // SquareUp manual card add logic
      appId: this.config.SQUARE.appId,
      locationId: this.config.SQUARE.locationId,
      payments: null,
      card: null,
      async initWalletPayments() {
        this.loading = true;
        try {
          this.payments = await this.square.payments(
            this.appId,
            this.locationId
          );
          console.log("payments");
          console.log(this.payments);
          this.card = await this.payments.card();
          await this.card.attach("#card-container");
          this.loading = false;
        } catch (e) {
          console.log("Error");
          console.log(e);
          return;
        }
      },
      async addCard() {
        this.loading2 = true;
        const tokenResult = await this.card.tokenize();
        console.log("AddCard token result:");
        console.log(tokenResult);

        this.$http
          .post(
            `${process.env.SERVER_URL}/942854760A354179AEA30A6C0767B45C`,
            {
              squareUptoken: tokenResult.token
            },
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("Add card response");
            console.log(response);
            if (response.data && response.status && response.status === 200) {
              if (this.$route.query.returnTo) {
                this.$router.push(`/${this.$route.query.returnTo}`);
              } else {
                this.$router.push("/cardsListSquare");
              }
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.error
            ) {
              text = error.response.data.error;
            }
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    // this.$storage.remove("parkendaToken");
                    // this.$router.push("/login");
                    this.$modal.hide("dialog");
                  }
                }
              ]
            });
          })
          .finally(() => {
            this.loading2 = false;
          });
      }
    };
  }
};
</script>

<style src="../../styles/main.css"></style>
<style scoped>
.v-spinner {
  padding: 43px;
  font-size: 10px;
}
.rest-text {
  color: gray;
  text-align: left;
  margin: 2vh auto;
  font-size: 3.5vw;
}
#payment-form {
  width: 80%;
  margin: 0 auto;
  background-color: #ffffff;
  height: 138px;
  padding: 35px 15px 0px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Cards/AddSquare.vue